import config from 'src/js/modules/config';
import featureFlagsManager from '@yola/feature-flags-manager';
import serviceClient from '../service-client';

const clientLoader = (store) => (next) => (action) => {
  switch (action.type) {
    case config.actionTypes.SET_SERVICE_CONFIG: {
      next(action);
      const state = store.getState();
      const apiUrl = config.selectors.getApiUrl(state);
      serviceClient.set(featureFlagsManager.initWith(apiUrl));
      break;
    }
    default: {
      next(action);
    }
  }
};

export default clientLoader;
